import { phoneNumberRegex } from 'utils/regex';

// eslint-disable-next-line import/prefer-default-export
export const isPhoneNumberValid = phone => RegExp(phoneNumberRegex).test(phone);
